export default {
  lineColor: "КЛ",
  lineColorFull: "Колір лінії",
  fillColor: "КЗ",
  fillColorFull: "Колір заливки",
  alpha: "Пр",
  alphaFull: "Прозорість",
  lineWidth: "ТЛ",
  lineWidthFull: "Товщина лінії",
  arrowLength: "ДЛ",
  arrowLengthFull: "Довжина стрілки",
  eraserWidth: "ШГ",
  eraserWidthFull: "Ширина гумки",
  textColor: "КТ",
  textColorFull: "Колір тексту",
  fontSize: "РШ",
  fontSizeFull: "Розмір шрифту",
  fontStrokeSize: "ТШ",
  fontStrokeSizeFull: "Ширина шрифту",
  fontIsBold: "<b>B</b>",
  fontIsBoldFull: "Жирний",
  fontIsItalic: "<i>I</i>",
  fontIsItalicFull: "Курсив",
  shadowOn: "Т",
  shadowOnFull: "Тінь",
  filtersFull: "Фільтри", 
  fontStrokeAndShadow: "Т+О",
  fontStrokeAndShadowFull: "Тінь та обводка",
  filters: 'Фільтр',
  imageFilters: 'Фільтри зображення',
  percents: "%",
  percentsFull: "Проценти",





  fontName: "НШ",
  fontNameFull: "Назва шрифту",
  textStrokeColor: "КО",
  textStrokeColorFull: "Колір обводки",
  apply: "Застосувати",
  cancel: "Відміна",
  close: "Закрити",
  clear: "Очистити",
  width: "Ширина",
  height: "Висота",
  keepRatio: "Зберегти пропорції ширини/висоти",
  fillPageWith: "Залити сторінку поточним кольором фону",
  pixelSize: "РП",
  pixelSizeFull: "Розмір пікселя",
  resizeScale: "Масштаб",
  resizeResize: "Змінити розмір",
  backgroundColor: "Колір фону сторінки",
  pixelizePixelSize: "Розмити пікселі розміром",
  language: "Мова",
  wrongPixelSizeValue:
    "Неправильний розмір пікселя. Ви можете ввести, наприклад, '20%', що означає, що середній розмір пікселя буде 1/5 від " +
    "сторони вибраної області, або '4', що означає 4 пікселя",
  tools: {
    crop: "Обрізати зображення до виділеної області",
    pixelize: "Зробити пікселізацію виділеної області",
    rect: "Намалювати прямокутник",
    ellipse: "Намалювати еліпс",
    line: "Намалювати лінію",
    arrow: "Намалювати стрілку",
    rotate: "Повернути ",
    save: "Зберегти ",
    load: "Завантажити ",
    text: "Вставити текст",
    brush: "Пензель",
    resize: "Змінити розмір або масштаб",
    open: "Відкрити зображення",
    select: "Вибрати область",
    close: "Закрити",
    eraser: "Ластик",
    settings: "Налаштування",
    zoomin: "Наблизити",
    zoomout: "Віддалити",
    undo: "Скасувати",
    redo: "Повторити",
    clear: "Очистити",
    bucket: "Заливка",
    filters: "Фільтри",
  },
  pasteOptions: {
    fit: "Замінити все",
    extend_down: "Додати вниз",
    extend_right: "Додати вправо",
    extend_left: "Додати вліво",
    extend_top: "Додати вгору",
    extend: "Додати",
    over: "Вставити",
    how_to_paste: "Як вставити?",
  },
};
